import axios from "axios";
import { Sign, ClientInfo, headData, perfectData } from './perfectData'

import { lang } from "@/util/base";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

import {
  RequestRecovery,
} from "xhwebtool";
window.Promise = Promise;

axios.defaults.timeout = 5000;
axios.defaults.withCredentials = true;
// 请求拦截器
axios.interceptors.request.use(
  async (config) => {
    config.url = RequestRecovery.replaceUrl2RetryApi(config.url);

    const headDatas = await headData(config.url)

    // 获取服务器时间接口不携带headers信息
    if (config.url.indexOf('/apiv1/comm/server-time') == -1) {
      // 写入头部
      config.headers['Client-Info'] = ClientInfo(headDatas);
      config.headers['Sign'] = Sign(headDatas);
      config.headers['Client-Lang'] = cookies.get("XH-WEB").page_lang || lang();
    }

    // 组装完整版本的请求参数，统一处理ts
    if (config.url.indexOf('/apiv1/comm/server-time') !== -1 || config.url.indexOf('/apiv1/comm/init') !== -1 || config.url.indexOf('/apiv1/comm/hybrid/country-info') !== -1) {
      config.data = perfectData({ ...config.data, ts: headDatas.ts }, 1)
    } else {
      config.data = perfectData({ ...config.data, ts: headDatas.ts })
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// 响应拦截器
axios.interceptors.response.use(
  async (response) => {
    // 在这里可以对响应做一些处理，比如根据返回码进行统一处理等
    const res = await RequestRecovery.fetch(response, axios);
    if (res.status === 200) {
      return res;
    } else {
      return Promise.reject(res);
    }
  },
  async (error) => {
    // 响应错误时做些事情
    const err = await RequestRecovery.fetch(error, axios);
    return Promise.reject(err);
  }
);

export const getFetch = async (url, params = {}) => {
  try {
    const response = await new Promise((resolve, reject) => {
      axios.get(url, {
        params: params,
        recoveryType: 4
      }).then((res) => {
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
    });

    return response;
  } catch (e) {
    return {
      code: -1,
      data: e.response?.data,
      message: e.message,
      status: false,
    };
  }
};

// 封装 post 请求
export const postFetch = async (url, params = {}, config = {}) => {
  const res = await axios.post(url, params, { ...config, recoveryType: 4 });
  const responseData = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

  if (res.status === 200) {
    if (url.includes('/apiv1/comm/server-time') || url.includes('/apiv1/comm/init')) {
      if (responseData.code === 200) {
        return responseData;
      } else {
        throw {
          code: responseData.code || -100,
          msg: responseData.msg || "服务器开小差了。",
          requestOption: { url, params }
        };
      }
    } else {
      return responseData;
    }
  } else {
    throw {
      code: responseData.code || -100,
      msg: responseData.msg || "服务器开小差了。",
      requestOption: { url, params }
    };
  }
};

